const getElementHeight = (selector) => {
  try {
    return document.querySelector(selector).offsetHeight;
  } catch (e) {
    return 0;
  }
};
export default getElementHeight;
